import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { Confirm } from '../../components/Confirm/Confirm';

export interface ConfirmWrap {
    message: string;
    declineText?: string;
    successText?: string;
    children?: React.ReactNode;
}

export function confirm(props: ConfirmWrap): Promise<void> {
    const wrapper = document.body.appendChild(document.createElement('div'));
    const cleanup = (): number => {
        ReactDOM.unmountComponentAtNode(wrapper);
        return window.setTimeout(function(): void {
            return wrapper.remove();
        });
    };

    return new Promise((resolve, reject): void => {
        const onConfirm = (): void => {
            cleanup();
            resolve();
        };

        const onCancel = (): void => {
            cleanup();
            reject();
        };

        const element = React.createElement(Confirm, {
            ...props,
            onSuccessClick: onConfirm,
            onDeclineClick: onCancel
        });

        ReactDOM.render(element, wrapper);
    });
}
